import { Component } from '@angular/core';
import { TimesheetPayrollAdjustmentApprovalsComponent } from '../timesheet-payroll-adjustment-approvals/timesheet-payroll-adjustment-approvals.component';

@Component({
  selector: 'ppl-timesheet-billing-adjustment-approvals',
  standalone: true,
  imports: [
    TimesheetPayrollAdjustmentApprovalsComponent
  ],
  templateUrl: './timesheet-billing-adjustment-approvals.component.html',
  styleUrl: './timesheet-billing-adjustment-approvals.component.css'
})
export class TimesheetBillingAdjustmentApprovalsComponent {

}
